import * as React from "react";
import { styled } from "@mui/material/styles";
import MuiDrawer from "@mui/material/Drawer";
import { AppBar, Typography, Box } from "@mui/material";
// import Close from "../../assets/images/Close.svg";
// import Open from "../../assets/images/Open.svg";
import { Button } from "@mui/material";
import PropTypes from "prop-types";
import { AddCircleOutlineOutlined } from "@mui/icons-material";
import VerticalTabs from "../VerticalTabs/VerticalTabs";
import { useSelector, useDispatch } from "react-redux";
import "./SideNavigation.scss";
import { getUserSessions } from "../../redux/slice/get-user-sessions";
import { useLocation } from "react-router-dom";

import { ReactComponent as OpenIcon } from "../../assets/images/Open.svg";
import { ReactComponent as CloseIcon } from "../../assets/images/Close.svg";

import {
  inputUpdate,
  resetMessages,
  disableFormContol,
  productsUpdate,
  keyMessageUpdate,
  newChatStateUpdate,
} from "../../redux/slice/snackbar";
// import { setSessionId } from "../../redux/slice/new-stream-thunk";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const drawerWidth = 328;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
  top: "61px",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `72px`,
  top: "61px",
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  // top: '61px',
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));
const NewChatButton = styled(Button)(({ theme }) => ({
  color: "#FFFFFF",
  backgroundColor: "#6D94A7",
  height: "48px",
  textTransform: "capitalize",
  fontSize: "14px",
  fontWeight: "bold",
  borderRadius: "4px",
  width: "100%",
  border: "none",
  // position: "fixed",
  // left: "2%",
  // width: "27%",
  top: "71px",
  border: "none",
  justifyContent: "center",
  "&:hover": {
    backgroundColor: "#396D87",
    color: "white",
    border: "1px solid #396D87",
  },
}));

const ButtonWithIcon = styled(Button)(() => ({
  display: "inline-block",
  position: "fixed",
  bottom: "10%",
  right: "3%",
}));

export default function SideNavigation(props) {
  const { open, handleDrawerOpen, handleDrawerClose } = props;
  const location = useLocation();
  const dispatch = useDispatch();

  const queryParams = new URLSearchParams(location.search);
  const authUser = useSelector((state) => state.auth.user);
  const userEmail = authUser?.email || "";
  const token = "__cookie__";
  // const client = queryParams.get("client");
  const client = "UT";
  const { loading } = useSelector((state) => state.stream);
  const newChatStreamLoading = useSelector(
    (state) => state.newChatStream.loading,
  );
  const { minRows, maxRows } = useSelector((state) => state.snackbar);
  const handleNewChatOpen = () => {
    // dispatch(setSessionId("")); // ✅ important: clear session so next send creates new one

    dispatch(inputUpdate(""));
    dispatch(resetMessages());
    dispatch(disableFormContol(false));
    dispatch(productsUpdate(""));
    dispatch(keyMessageUpdate(""));
    dispatch(newChatStateUpdate(true));

    const userSessionPayload = { userEmail, token, client, minRows, maxRows };
    dispatch(getUserSessions(userSessionPayload));
  };

  return (
    <Drawer
      variant="permanent"
      open={open}
      anchor="left"
      className="drawer-parent"
    >
      <DrawerHeader bg="white" className="drawerHeader">
        {open ? (
          <AppBar position="fixed" className="appbar-opened">
            <NewChatButton
              variant="outlined"
              startIcon={<AddCircleOutlineOutlined />}
              className="new-button-opened"
              onClick={handleNewChatOpen}
              disabled={loading || newChatStreamLoading}
            >
              New Session
            </NewChatButton>
          </AppBar>
        ) : (
          <Button
            onClick={handleNewChatOpen}
            className="closedNewChat"
            disabled={loading || newChatStreamLoading}
          >
            <AddCircleOutlineOutlined />
          </Button>
        )}
      </DrawerHeader>
      <VerticalTabs open={open} handleDrawerOpen={handleDrawerOpen} />
      {open ? (
        <ButtonWithIcon
          onClick={handleDrawerClose}
          className="opened-icon-button"
        >
          <OpenIcon className="icon" />
        </ButtonWithIcon>
      ) : (
        <Button onClick={handleDrawerOpen} className="closed-icon-button">
          <CloseIcon className="icon" />
        </Button>
      )}
    </Drawer>
  );
}
